/***** Contact Form *****/

$(document).ready(function() {
    $('.field__input').focus(function() {
      if ($(this).val() === '') {
        // Use 'siblings' to select the label for the current input field
        $(this).siblings('.field__label').hide();
      }
    });

    $('.field__input').blur(function() {
        if ($(this).val() === '') {
            // Use 'siblings' to select the label for the current input field
            $(this).siblings('.field__label').show();
        }
    });
});

/***** End *****/

/******Blog Page Filters*******/
document.addEventListener('DOMContentLoaded', function() {
    // Select all blog articles
    const articles = document.querySelectorAll('.blog-articles__article');

    // Get filter dropdowns
    const titleFilter = document.getElementById('filter-title');
    const authorFilter = document.getElementById('filter-author');
    const dateFilter = document.getElementById('filter-date');

    // Populate dropdowns with unique titles, authors, and dates
    const titles = new Set();
    const authors = new Set();
    const dates = new Set();

    articles.forEach(article => {
        const titleElement = article.querySelector('.card__heading a');
        const title = titleElement ? titleElement.textContent.trim() : '';

        const authorElement = article.querySelector('.article-card__info span:nth-of-type(2)');
        const author = authorElement ? authorElement.textContent.trim() : '';

        const dateElement = article.querySelector('.article-card__info span:first-of-type');
        const date = dateElement ? dateElement.textContent.trim() : '';

        if (title) titles.add(title);
        if (author) authors.add(author);
        if (date) dates.add(date);
    });

    // Populate the dropdowns with unique values
    titles.forEach(title => {
        const option = document.createElement('option');
        option.value = title;
        option.textContent = title;
        titleFilter.appendChild(option);
    });

    authors.forEach(author => {
        const option = document.createElement('option');
        option.value = author;
        option.textContent = author;
        authorFilter.appendChild(option);
    });

    dates.forEach(date => {
        const option = document.createElement('option');
        option.value = date;
        option.textContent = date;
        dateFilter.appendChild(option);
    });

    // Function to filter articles based on selected criteria
    function filterArticles() {
        const selectedTitle = titleFilter.value;
        const selectedAuthor = authorFilter.value;
        const selectedDate = dateFilter.value;

        articles.forEach(article => {
            const titleElement = article.querySelector('.card__heading a');
            const title = titleElement ? titleElement.textContent.trim() : '';

            const authorElement = article.querySelector('.article-card__info span:nth-of-type(2)');
            const author = authorElement ? authorElement.textContent.trim() : '';

            const dateElement = article.querySelector('.article-card__info span:first-of-type');
            const date = dateElement ? dateElement.textContent.trim() : '';

            // Check if the article matches the selected filters
            const matchesTitle = !selectedTitle || title === selectedTitle;
            const matchesAuthor = !selectedAuthor || author === selectedAuthor;
            const matchesDate = !selectedDate || date === selectedDate;

            if (matchesTitle && matchesAuthor && matchesDate) {
                article.style.display = 'block'; // Show matching articles
            } else {
                article.style.display = 'none'; // Hide non-matching articles
            }
        });
    }

    // Add event listeners to filter dropdowns
    titleFilter.addEventListener('change', filterArticles);
    authorFilter.addEventListener('change', filterArticles);
    dateFilter.addEventListener('change', filterArticles);
});

/******End*******/


